import React from 'react'
import Chart from "react-apexcharts"

export default function CourseStatistics(props) {

    const { graph } = props

    const status = graph && graph.map(val => val.status)
    const percent = graph && graph.map(val => val.percentage)

    var series = percent ? percent : []
    var options = {
        colors: ['#FF3961', '#00E49B', '#FFAD36'],
        chart: {
            type: 'donut',
        },
        labels: status ? status : [],
        legend: {
            position: 'top'
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    }

    return (
        <>
            <div>
                <div className='dash_head'>
                    <h5>Learning Module Statistics / Progress</h5>
                </div>

                <Chart options={options} series={series} type="donut" height='auto' width='100%' />

            </div>
        </>
    )
}
